import { MemberGender, MemberMaritalStatus } from '@vista-digital/ocapi-types/v1';
import { mapMemberFormDataToContactDetails } from './map-member-form-data-to-contact-details';
import { mapMemberFormDataToPreferences } from './map-member-form-data-to-preferences';
export const mapMemberFormDataToPersonalDetails = (formData) => {
    const { givenName, familyName, dateOfBirth, gender, nationalId, externalId } = formData;
    return {
        name: {
            givenName: givenName || undefined,
            familyName: familyName || undefined
        },
        gender: gender || MemberGender.NotSpecified,
        maritalStatus: MemberMaritalStatus.NotSpecified,
        interestSubscriptions: [],
        contactDetails: mapMemberFormDataToContactDetails(formData),
        preferences: mapMemberFormDataToPreferences(formData),
        birthDate: dateOfBirth || undefined,
        nationalId: nationalId || undefined,
        externalId: externalId || undefined
    };
};
//# sourceMappingURL=map-member-form-data-to-personal-details.js.map